module.exports = __webpack_public_path__ + "static/media/intro.e515b7c7.mp3";